import React, { useState } from "react";
import StarRatings from "react-star-ratings";
import toast from "react-hot-toast";
import { useSubmitReviewMutation } from "../../redux/api/productsApi";

const NewReview = ({ productId }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const [submitReview] = useSubmitReviewMutation();

  const MAX_LENGTH = 300;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rating) return toast.error("Select a rating");
    if (!comment.trim()) return toast.error("Enter a review");

    try {
      setLoading(true);

      await submitReview({
        rating,
        comment: comment.trim(),
        productId,
      }).unwrap();

      toast.success("Review submitted");

      setRating(0);
      setComment("");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to submit");
    } finally {
      setLoading(false);
    }
  };

  const isDisabled =
    loading || !rating || !comment.trim() || comment.length > MAX_LENGTH;

  return (
    <div className="mt-10 bg-[#f5f3ea] rounded-md p-5 border border-[#8a4b32]/10">
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Rating (less visual dominance) */}
        <div className="opacity-90">
          <StarRatings
            rating={rating}
            starRatedColor="#C19A6B"
            starHoverColor="#BC3F4A"
            starEmptyColor="#EADDCA"
            changeRating={setRating}
            numberOfStars={5}
            starDimension="24px"
            starSpacing="3px"
            name="rating"
          />
        </div>

        {/* Comment */}
        <div>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
            maxLength={MAX_LENGTH}
            placeholder="Write your review"
            className="w-full p-3 bg-[#fffdf8]
                       border border-[#8a4b32]/10
                       rounded-md
                       focus:outline-none focus:ring-1 focus:ring-[#BC3F4A]/40
                       font-sourcesans text-[#1c1917] resize-none"
          />

          <div className="text-right text-xs text-[#6b4f3a]/70 mt-1">
            {comment.length}/{MAX_LENGTH}
          </div>
        </div>

        {/* Button (less aggressive) */}
        <button
          type="submit"
          disabled={isDisabled}
          className="w-full py-2.5 rounded-md
                     bg-[#BC3F4A]/90 text-white
                     font-playfair text-sm
                     transition hover:bg-[#BC3F4A]
                     disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {loading ? "Submitting..." : "Submit Review"}
        </button>

      </form>
    </div>
  );
};

export default NewReview;